import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bestpractice',
  templateUrl: './bestpractice.component.html',
  styleUrls: ['./bestpractice.component.scss']
})
export class BestpracticeComponent implements OnInit {

  results: any;
  activityLog: any;

  constructor() { }

  ngOnInit() {
    this.results = [
      {id: 1, count: 50, percentage: 100, label: 'Invited'},
      {id: 2, count: 20, percentage: 40, label: 'Assessed'},
      {id: 3, count: 30, percentage: 60, label: 'Qualified'}
    ];
    this.activityLog = [
      {id: 1, email: 'bjvr@gmail.com', status: 'Completed assessment' , time: '10/03/20, 8:36'},
      {id: 2, email: 'bjvr@gmail.com', status: 'Completed assessment' , time: '10/03/20, 8:36'},
      {id: 3, email: 'bjvr@gmail.com', status: 'Completed assessment' , time: '10/03/20, 8:36'},
      {id: 4, email: 'bjvr@gmail.com', status: 'Completed assessment' , time: '10/03/20, 8:36'},
      {id: 5, email: 'bjvr@gmail.com', status: 'Completed assessment' , time: '10/03/20, 8:36'},
      {id: 6, email: 'bjvr@gmail.com', status: 'Completed assessment' , time: '10/03/20, 8:36'},
      {id: 7, email: 'bjvr@gmail.com', status: 'Completed assessment' , time: '10/03/20, 8:36'},
      {id: 8, email: 'bjvr@gmail.com', status: 'Completed assessment' , time: '10/03/20, 8:36'},
      {id: 10, email: 'bjvr@gmail.com', status: 'Completed assessment' , time: '10/03/20, 8:36'}
  ];
  }

}
